<template>
    <div>
        <residential-canteen-relations-form :entity-id="entityId">
        </residential-canteen-relations-form>
    </div>
</template>

<script>
import residentialCanteenRelationsForm from '@/components/pages/residentialCanteens/relations/Form'
import dirtyForm from '@/components/mixins/dirtyForm'

export default {
    components: {
        residentialCanteenRelationsForm,
    },
    mixins: [dirtyForm],

    data() {
        return {
            entityId: null,
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                this.entityId = route.params.entityId
            },
        },
    },
}
</script>
